<template>
  <div class="generateStyle aiPageBg">
    <navbar :nav="nav"></navbar>
    <div class="styleContent baseStyle">
      <div class="title">文言を入力し画像を生成します</div>
      <div
        class="textareaBox"
        :class="message.length > 200 ? 'textareaMax' : ''"
      >
        <van-field
          :class="textareaFocus ? 'textareaFocus' : ''"
          v-model="message"
          autosize
          rows="2"
          type="textarea"
          placeholder=""
          show-word-limit
          @change="changeTextarea"
          @focus="textareaFocus = true"
          @blur="textareaFocus = false"
        />
        <div class="textareaLength">{{ message.length }}/200</div>
      </div>
      <div class="styleTitle">スタイルを選択</div>
      <div class="styleDesc">
        表示されているイメージはあくまでサンプルです。
      </div>
      <div class="styleItems">
        <div
          class="items"
          :class="item.check ? 'check' : ''"
          v-for="(item, index) in imgData"
          :key="index"
          @click="checkImgStyle(index)"
        >
          <img
            class="img"
            v-if="item.value == 9"
            src="../../assets/img/imgStyle1.png"
          />
          <img
            class="img"
            v-if="item.value == 2"
            src="../../assets/img/imgStyle2.png"
          />
          <img
            class="img"
            v-if="item.value == 1"
            src="../../assets/img/imgStyle3.png"
          />
          <img
            class="img"
            v-if="item.value == 3"
            src="../../assets/img/imgStyle4.png"
          />
          <img
            class="img"
            v-if="item.value == 5"
            src="../../assets/img/imgStyle5.png"
          />
          <img
            class="img"
            v-if="item.value == 4"
            src="../../assets/img/imgStyle6.png"
          />
          <img
            class="img"
            v-if="item.value == 6"
            src="../../assets/img/imgStyle7.png"
          />
          <img
            class="img"
            v-if="item.value == 7"
            src="../../assets/img/imgStyle8.png"
          />
          <img
            class="img"
            v-if="item.value == 8"
            src="../../assets/img/imgStyle9.png"
          />
          <div class="text">{{ item.text }}</div>
          <img
            class="icon"
            v-show="item.check"
            src="../../assets/img/icon/icon_check.png"
          />
        </div>
      </div>
      <van-button
        round
        block
        type="info"
        native-type="submit"
        class="buttonBlue"
        :loading="loading"
        @click="goResult()"
        >生成</van-button
      >

      <van-popup v-model="goResultPopup">
        <div class="content">
          <div>ご指定の文字数内で入力してください。</div>
          <div class="minText">
            文字数が多い場合、生成される画像の品質が低下する可能性があります。
          </div>
        </div>
        <div class="buttonItem">
          <div class="button cancel" @click="goResultPopup = false">
            文言修正
          </div>
          <div class="button sure" @click="shengcheng()">
            このまま生成
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);
import navbar from "../../components/navbar/index.vue";
import { genImages } from "@/http/home";
export default {
  components: {
    navbar
  },
  data() {
    return {
      nav: {
        back: true,
        title: "生成設定",
        chat: true
      },
      message: "",
      textareaLength: 0,
      textareaFocus: false,
      imgData: [
        { check: true, text: "アニメ", value: 1 },
        { check: false, text: "写真", value: 2 },
        { check: false, text: "3Dレンダー", value: 3 },
        { check: false, text: "イラスト", value: 4 },
        { check: false, text: "アメコミ", value: 5 },
        { check: false, text: "デジタルアート", value: 6 },
        { check: false, text: "水彩", value: 7 },
        { check: false, text: "浮世絵", value: 8 },
        { check: false, text: "おまかせ", value: 9 }
      ],
      messageType: 1,
      goResultPopup: false,
      loading: false
    };
  },
  created() {
    Toast.clear();
  },
  mounted() {
    let text = this.$route.query.text;
    // this.message = text;
    this.message = text.replaceAll(",", "'");
  },
  methods: {
    changeTextarea() {
      console.log("changeTextarea", this.message, this.message.length);
    },
    checkImgStyle(index) {
      let arr = this.imgData;
      for (let i in arr) {
        arr[i].check = false;
      }
      this.messageType = this.imgData[index].value;
      this.imgData[index].check = true;
    },
    goResult() {
      if (this.message.length > 200) {
        this.goResultPopup = true;
        return false;
      } else {
        this.shengcheng();
      }
    },
    shengcheng() {
      document.documentElement.scrollTop = 0;
      localStorage.setItem("message", this.message);
      localStorage.setItem("messageType", this.messageType);
      localStorage.removeItem("imgId");
      this.$router.push({
        path: `/generateResult`,
        query: { ai: "" }
        // query: { message: this.message, messageType: this.messageType}
      });
      // Toast.loading({
      //   message: "加载中...",
      //   duration: 0,
      //   forbidClick: true
      // });
      // this.loading = true;
      // genImages({
      //   requestMessageContent: this.message,
      //   messageType: this.messageType
      // }).then(res => {
      //   let { data, code } = res.data;
      //   if (code == 200) {
      //     console.log('data',data)
      //     this.loading = false;
      //     Toast.clear();
      //     let content = data.responseMessageContent
      //     this.$router.push({
      //       path: `/generateResult`,
      //       // path: `/generateResultChat`,
      //       // query: { id: JSON.stringify(data) }
      //       query: { id: content }
      //     });
      //     // console.log("genImages", data);
      //   }
      // });
    }
  }
};
</script>

<style>
.styleContent {
  /* width: calc(100% - 30px); */
  padding: 0 15px 15px 15px;
  height: calc(100% - 15px);
  width: 100%;
  box-sizing: border-box;
  position: relative;
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
}
.styleContent .title {
  font-family: MediumFont;
  font-size: 18px;
  font-weight: normal;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.9);
  margin: 0 0 16px 0;
}
.styleContent .textareaBox {
  position: relative;
}
.styleContent .textareaBox .textareaLength {
  position: absolute;
  right: 16px;
  bottom: 10px;
  z-index: 6;
  font-size: 12px;
  font-weight: normal;
  line-height: 21px;
  color: rgb(0, 0, 0, 0.5);
}
.styleContent .van-cell {
  width: 100%;
  height: 116px;
  border-radius: 12px;
  line-height: 22px;
  font-size: 16px;
  padding: 0 16px;
  border: 1.5px solid #fff;
  box-sizing: border-box;
}
.styleContent .van-cell::after {
  border: none;
}
.styleContent .van-cell.textareaFocus {
  border: 1.5px solid #2b99ff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0);
}
.styleContent .van-field__body {
  /* height: 70px; */
  /* height: 70px; */
  /* overflow: auto;
  padding: 16px 0; */
  height: 70px;
  overflow: auto;
  /* padding: 0.426667rem 0; */
  box-sizing: border-box;
  margin-top: 15px;
  /* padding-top: 28px; */
  align-items: flex-start;
}
.styleContent .van-field__control {
  font-family: RegularFont;
  font-size: 16px;
  font-weight: normal;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.9);
}
.styleContent .van-field__word-limit {
  font-family: RegularFont;
  font-size: 12px;
  font-weight: normal;
  line-height: 21px;
  color: rgb(0, 0, 0, 0.5);
}
.styleContent .textareaBox.textareaMax .van-cell.textareaFocus {
  border: 1.5px solid #ff2f6a;
}
.styleContent .textareaBox.textareaMax .textareaLength {
  color: #ff2f6a;
}
.styleTitle {
  font-family: MediumFont;
  font-size: 18px;
  font-weight: normal;
  line-height: 22px;
  margin: 16px 0 0 0;
  /* 11.Black/Alpha 0.9-填充 */
  color: rgba(0, 0, 0, 0.9);
}
.styleDesc {
  font-family: MediumFont;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  margin: 6px 0 16px 0;
  /* 11.Black/Alpha 0.9-填充 */
  color: rgba(0, 0, 0, 0.6);
}
.styleItems {
  margin-bottom: 30px;
}
.styleItems .items {
  width: calc(33.3% - 11px);
  height: 142px;
  margin: 0 15px 8px 0;
  display: inline-block;
  position: relative;
}
.styleItems .items:nth-child(3n) {
  margin-right: 0;
}
.styleItems .items .img {
  width: 100%;
  height: 110px;
  border-radius: 4px;
  object-fit:cover;
}
.styleItems .items.check .img {
  border: 2px solid #0dd43b;
}
.styleItems .items .text {
  line-height: 24px;
  margin-top: 6px;
  font-size: 14px;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
}
.styleItems .items .icon {
  position: absolute;
  right: 6px;
  bottom: 38px;
  z-index: 2;
  width: 16px;
  height: 16px;
}
@media screen and (min-width: 1439px) {
  .styleContent {
    height: calc(100% - 15px); /* no*/
    padding: 0 15px 15px 15px; /* no*/
  }
  .styleContent .title {
    font-size: 18px; /* no*/
    line-height: 22px; /* no*/
    margin: 0 0 16px 0; /* no*/
    width: calc(100% - 30px); /* no*/
    padding: 0 15px; /* no*/
  }
  .styleContent .van-cell {
    width: 100%; /* no*/
    height: 114px; /* no*/
    border-radius: 12px; /* no*/
    line-height: 22px; /* no*/
    font-size: 16px; /* no*/
    padding: 0 16px; /* no*/
    border: 1.5px solid #fff; /* no*/
  }
  .styleContent .van-cell.textareaFocus {
    border: 1.5px solid #2b99ff; /* no*/
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0); /* no*/
  }
  .styleContent .van-field__body {
    height: 70px; /* no*/
    margin-top: 15px; /* no*/
  }
  .styleContent .van-field__control {
    font-size: 16px; /* no*/
    line-height: 22px; /* no*/
  }
  .styleContent .van-field__word-limit {
    font-size: 12px; /* no*/
    line-height: 21px; /* no*/
  }
  .styleTitle {
    font-size: 18px; /* no*/
    line-height: 22px; /* no*/
    margin: 16px 0 0 0; /* no*/
  }
  .styleDesc {
    font-size: 16px; /* no*/
    line-height: 22px; /* no*/
    margin: 6px 0 16px 0; /* no*/
  }
  .styleItems .items .text {
    line-height: 24px; /* no*/
    margin-top: 6px; /* no*/
    font-size: 14px; /* no*/
  }
  .styleItems .items {
    width: calc(33.3% - 11px); /* no*/
    height: 195px; /* no*/
    margin: 0 15px 8px 0; /* no*/
  }
  .styleItems .items .img {
    height: 152px; /* no*/
  }
  .styleItems .items .icon {
    right: 6px; /* no*/
    bottom: 48px; /* no*/
    z-index: 2; /* no*/
    width: 22px; /* no*/
    height: 22px; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/chat/generateStyle.vue